import React, { useEffect, useState } from "react";
import Input from "../../../CoreComponent/Input";
import Select from "../../../CoreComponent/Select";
import Checkbox from "../../../CoreComponent/Checkbox";
import DateInput from "../../../CoreComponent/Date";
import deleteIcon from "../../../icons/deleteIcon.svg";
import { useStepper } from "../StepperContext";
import SVG from "react-inlinesvg";
import toast from "react-hot-toast";
import "./style.scss";
import { Button, Divider, Grid } from "@mui/material";

// ✅ AUTO CALCULATE TOTAL NIGHTS FUNCTION
const calculateTotalNights = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return "";
  
  try {
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);
    
    if (isNaN(checkInDate.getTime()) || isNaN(checkOutDate.getTime())) {
      return "";
    }
    
    const timeDiff = checkOutDate.getTime() - checkInDate.getTime();
    const nights = Math.ceil(timeDiff / (1000 * 3600 * 24));
    
    return nights > 0 ? nights.toString() : "";
  } catch (error) {
    return "";
  }
};

const RoomForm = () => {
  const { currentStep, completeStep, rooms, setRooms } = useStepper();

  const initialValue = {
    roomType: "",
    occupantName: "",
    specialRequests: "",
    checkInDate: "",
    checkOutDate: "",
    lateCheckOut: false,
    earlyCheckIn: false,
    totalNights: "",
  };

  const options = [
    { value: "Single", label: "Single" },
    { value: "Double", label: "Double" },
    { value: "Triple", label: "Triple" },
  ];

  // ✅ AUTO CALCULATE NIGHTS HANDLER
  const handleDateChange = (index, field, value) => {
    const updatedRooms = rooms.map((room, i) =>
      i === index ? { ...room, [field]: value } : room
    );
    setRooms(updatedRooms);

    // ✅ AUTO CALCULATE TOTAL NIGHTS
    if (field === "checkInDate" || field === "checkOutDate") {
      const room = updatedRooms[index];
      const nights = calculateTotalNights(room.checkInDate, room.checkOutDate);
      const finalRooms = updatedRooms.map((r, i) =>
        i === index ? { ...r, totalNights: nights } : r
      );
      setRooms(finalRooms);
    }
  };

  const addRoom = () => {
    setRooms([...rooms, { ...initialValue }]);
  };

  const deleteRoom = (index) => {
    setRooms(rooms.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updatedRooms = rooms.map((room, i) =>
      i === index ? { ...room, [field]: value } : room
    );
    setRooms(updatedRooms);
  };

  // ✅ BETTER VALIDATION FOR SUBMIT
  const isFormValid = () => {
    return rooms.every(room => 
      room.roomType && 
      room.occupantName && 
      room.checkInDate && 
      room.checkOutDate && 
      room.totalNights
    );
  };

  const handleSubmit = () => {
    if (!isFormValid()) {
      toast.error("Please fill all required fields for all rooms!");
      return;
    }
    toast.success("The data was updated successfully!");
    completeStep(currentStep);
  };

  return (
    <div>
      <div className="add-room-btn-container77">
        <button type="button" onClick={addRoom}>
          Add Room
        </button>
      </div>

      <form>
        {rooms.map((room, index) => (
          <div key={index}>
            <div className="delete-icon-container">
              <SVG
                className="delete-icon"
                src={deleteIcon}
                onClick={() => deleteRoom(index)}
              />
            </div>

            <Grid container spacing={2} sx={{ marginTop: "20px" }}>
              {/* Room Type */}
              <Grid item xs={12} md={6}>
                <Select
                  options={options}
                  value={room.roomType}
                  setValue={(value) => handleChange(index, "roomType", value)}
                  label="Room Type *"
                  required={true}
                />
              </Grid>

              {/* Occupant Name */}
              <Grid item xs={12} md={6}>
                <Input
                  label="Occupant Name *"
                  type="text"
                  inputValue={room.occupantName}
                  setInputValue={(value) => handleChange(index, "occupantName", value)}
                  placeholder="Enter occupant name"
                />
              </Grid>

              {/* Late Check Out */}
              <Grid item xs={12} md={6}>
                <div className="check-in-input-container">
                  <Checkbox
                    label="Late Check Out?"
                    checkboxValue={room.lateCheckOut}
                    setCheckboxValue={(value) => handleChange(index, "lateCheckOut", value)}
                  />
                </div>
              </Grid>

              {/* Check In Date */}
              <Grid item xs={12} md={6}>
                <DateInput
                  label="Check In Date *"
                  type="datetime-local"
                  inputValue={room.checkInDate}
                  setInputValue={(value) => handleDateChange(index, "checkInDate", value)}
                />
              </Grid>

              {/* Early Check In */}
              <Grid item xs={12} md={6}>
                <div className="check-in-input-container">
                  <Checkbox
                    label="Early Check In?"
                    checkboxValue={room.earlyCheckIn}
                    setCheckboxValue={(value) => handleChange(index, "earlyCheckIn", value)}
                  />
                </div>
              </Grid>

              {/* Check Out Date */}
              <Grid item xs={12} md={6}>
                <DateInput
                  label="Check Out Date *"
                  type="datetime-local"
                  inputValue={room.checkOutDate}
                  setInputValue={(value) => handleDateChange(index, "checkOutDate", value)}
                />
              </Grid>

              {/* Total Nights - ✅ AUTO CALCULATED & READONLY */}
              <Grid item xs={12} md={6}>
                <Input
                  label="Total Nights *"
                  type="number"
                  inputValue={room.totalNights}
                  setInputValue={() => {}} // Empty - user can't edit
                  placeholder="Auto calculated from dates"
                  disabled={true}
                />
              </Grid>
            </Grid>
            <Divider
              sx={{
                color: "black",
                marginTop: "10px",
                backgroundColor: "black",
              }}
            />
          </div>
        ))}
      </form>
      
      <div className="actions-section">
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#c62828',
            marginTop: "20px",
            color: "#fff",
            width: "100%",
            "&:hover": {
              backgroundColor: "#e63946",
              color: "#fff",
            }
          }}
          className="next-button"
          onClick={handleSubmit}
          disabled={!isFormValid()}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default RoomForm;
